import React from "react";
import styled from "styled-components";
import theme from "theme";
import { communityVelocity, sectionIds } from "content/site";
import { Container, Section, SectionTitle, SectionLead, TextLink } from "components/marketing/primitives";

const Panel = styled.div`
	border: 1px solid ${theme.color.border};
	border-radius: ${theme.radius.lg};
	background: ${theme.color.surface};
	box-shadow: ${theme.boxShadow.card};
	padding: 1.35rem 1.5rem;
	margin-bottom: 1.35rem;
`;

const LinkStack = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.65rem;
	align-items: flex-start;
`;

const Notes = styled.ul`
	margin: 0;
	padding-left: 1.2rem;
	font-family: ${theme.fontFamily.sans};
	font-size: 0.9375rem;
	color: ${theme.color.greyD2};
	line-height: 1.55;
	max-width: 40rem;
`;

export default function CommunityVelocity() {
	return (
		<Section id={sectionIds.community} aria-labelledby="community-heading" $alt>
			<Container>
				<SectionTitle id="community-heading">{communityVelocity.title}</SectionTitle>
				<SectionLead>{communityVelocity.lead}</SectionLead>
				<Panel>
					<LinkStack>
						{communityVelocity.links.map((l) => (
							<TextLink key={l.href} href={l.href}>
								{l.label} →
							</TextLink>
						))}
					</LinkStack>
				</Panel>
				<Notes>
					{communityVelocity.notes.map((n) => (
						<li key={n}>{n}</li>
					))}
				</Notes>
			</Container>
		</Section>
	);
}
